import { createReducer } from '@reduxjs/toolkit';
import _keyBy from 'lodash/keyBy';
import {
  savePricing,
  saveUpdatedChoices,
  updateSelectedChoice,
  setGuidedOptionFilter,
  updateCarpetPrice,
  savePricingDetailsFromThd,
} from '../actions';

export const initialState = {
  skuPrices: [],
  choicesWithPrices: [],
  selectedChoice: {},
  filters: {
    carpetType: '',
    colorFamily: '',
    brands: '',
    warranties: '',
  },
  totalCarpetPrice: 0,
  pricingDetailsFromThd: {},
};

const compareChoiceIdAndSku = (choice, id, sku) => {
  if (sku) {
    return choice.id === id && choice.sku === sku;
  }
  return choice.id === id;
};

export const pricing = createReducer(initialState,
  (builder) => builder
    .addCase(savePricing, (state, action) => ({ ...state, skuPrices: [...action.payload] }))
    .addCase(updateCarpetPrice, (state, action) => ({ ...state, totalCarpetPrice: parseFloat(action.payload) }))
    .addCase(savePricingDetailsFromThd, (state, action) => ({ ...state, pricingDetailsFromThd: { ...action.payload } }))
    .addCase(saveUpdatedChoices, (state, action) => {
      const previousChoices = _keyBy(state.choicesWithPrices, 'id');
      const updatedChoices = action.payload.map((choice) => ({
        ...choice,
        isSelected: (choice.id in previousChoices && previousChoices[choice.id].isSelected),
      }));
      return ({ ...state, choicesWithPrices: updatedChoices });
    })
    .addCase(updateSelectedChoice, (state, action) => {
      const { id, sku = null } = action.payload;
      const newState = state.choicesWithPrices.map((choice) => {
        return ({
          ...choice,
          isSelected: compareChoiceIdAndSku(choice, id, sku),
          isAvailable: choice.priceSquareFoot > 0
        });
      });
      return {
        ...state,
        choicesWithPrices: [...newState],
        selectedChoice: newState.find((choice) => choice.isSelected) // does this need to be based on isAvailable also?
      };
    })
    .addCase(setGuidedOptionFilter, (state, action) => {
      let newFilters = state.filters;
      if (action.payload.filterType === 'carpetType') {
        newFilters = { ...newFilters, carpetType: action.payload.data };
      } else if (action.payload.filterType === 'colorFamily') {
        newFilters = { ...newFilters, colorFamily: action.payload.data };
      } else if (action.payload.filterType === 'brands') {
        newFilters = { ...newFilters, brands: action.payload.data };
      } else if (action.payload.filterType === 'warranties') {
        newFilters = { ...newFilters, warranties: action.payload.data };
      }

      return { ...state, filters: newFilters };
    })
);
